import React, { Component } from 'react';
import ReactCrop from 'react-image-crop';
import loadImage from 'blueimp-load-image';
import './assets/custom-image-crop.css';
import Compressor from 'compressorjs';

import { base64StringtoFile,
  extractImageFileExtensionFromBase64,
  image64toCanvasRef } from './assets/ResuableUtils';
import AuthService from './AuthService';

import whiteBox from './assets/White_square.png';
import constants from '../config';
import { resolveCardImage } from '../utils/resolveImage';

const Auth = new AuthService();
const imageMaxSize = 1000000000;
const acceptedFileTypes = 'image/x-png, image/png, image/jpg, image/jpeg, image/gif';
const acceptedFileTypesArray = acceptedFileTypes.split(',').map(function(item) { return item.trim(); });


function AvatarCropModal(props) {
  var card = props.card;
  var zoom = props.zoom;
  var offset = props.offset;
  var saving = props.saving;
  var containerSize = 260;
  var imgUrl = resolveCardImage(card.image);

  // Image transform: centered, then offset + zoom
  var imgStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    height: 'auto',
    transform: 'translate(-50%, -50%) translate(' + offset.x + 'px, ' + offset.y + 'px) scale(' + zoom + ')',
    pointerEvents: 'none',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  };

  // Circular mask: radial gradient with transparent center, dark edges
  var maskStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'radial-gradient(circle at center, transparent 46%, rgba(0,0,0,0.6) 47%)',
    pointerEvents: 'none',
    borderRadius: '8px',
  };

  // Gold circle border overlay
  var circleBorderStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: containerSize * 0.92 + 'px',
    height: containerSize * 0.92 + 'px',
    borderRadius: '50%',
    border: '2px solid #c9a84c',
    pointerEvents: 'none',
  };

  var isDark = document.documentElement.classList.contains('tw-dark');

  return (
    <div
      className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-p-4"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
      onClick={function(e) { if (e.target === e.currentTarget) props.onCancel(); }}
    >
      <div
        className="tw-w-full tw-rounded-xl tw-overflow-hidden"
        style={{
          maxWidth: '380px',
          backgroundColor: isDark ? '#1a1a1a' : '#fff',
          border: isDark ? '1px solid #333' : '1px solid #e0e0e0',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
      >
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-4" style={{ borderBottom: isDark ? '1px solid #333' : '1px solid #e0e0e0' }}>
          <h3 className="tw-text-base tw-font-semibold" style={{ color: isDark ? '#fff' : '#111', margin: 0 }}>
            Adjust Your Avatar
          </h3>
          <button
            onClick={props.onCancel}
            className="tw-border-none tw-bg-transparent tw-cursor-pointer tw-p-1"
            style={{ color: isDark ? '#aaa' : '#888', fontSize: '18px' }}
          >
            <i className="fa fa-times"></i>
          </button>
        </div>

        {/* Preview Area */}
        <div className="tw-px-5 tw-pt-5">
          <div
            style={{
              width: containerSize + 'px',
              height: containerSize + 'px',
              margin: '0 auto',
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '8px',
              backgroundColor: isDark ? '#0f0f0f' : '#f5f5f5',
              cursor: props.dragging ? 'grabbing' : 'grab',
              touchAction: 'none',
            }}
            onMouseDown={props.onMouseDown}
            onMouseMove={props.onMouseMove}
            onMouseUp={props.onMouseUp}
            onMouseLeave={props.onMouseUp}
            onTouchStart={props.onTouchStart}
            onTouchMove={props.onTouchMove}
            onTouchEnd={props.onTouchEnd}
          >
            <img src={imgUrl} alt={card.name} style={imgStyle} draggable="false" />
            <div style={maskStyle}></div>
            <div style={circleBorderStyle}></div>
          </div>
        </div>

        {/* Zoom Slider */}
        <div className="tw-px-5 tw-pt-4">
          <div className="tw-flex tw-items-center tw-gap-3">
            <i className="fa fa-search-minus" style={{ color: isDark ? '#888' : '#aaa', fontSize: '14px' }}></i>
            <input
              type="range"
              min="1.4"
              max="4"
              step="0.1"
              value={zoom}
              onChange={props.onZoomChange}
              className="tw-flex-1"
              style={{
                height: '4px',
                WebkitAppearance: 'none',
                appearance: 'none',
                background: 'linear-gradient(to right, #c9a84c, #c9a84c ' + ((zoom - 1.4) / 2.6 * 100) + '%, ' + (isDark ? '#333' : '#ddd') + ' ' + ((zoom - 1.4) / 2.6 * 100) + '%, ' + (isDark ? '#333' : '#ddd') + ')',
                borderRadius: '2px',
                outline: 'none',
                cursor: 'pointer',
              }}
            />
            <i className="fa fa-search-plus" style={{ color: isDark ? '#888' : '#aaa', fontSize: '14px' }}></i>
          </div>
        </div>

        {/* Help Text */}
        <div className="tw-px-5 tw-pt-2">
          <p className="tw-text-xs tw-text-center" style={{ color: isDark ? '#666' : '#aaa', margin: 0 }}>
            Drag to reposition
          </p>
        </div>

        {/* Buttons */}
        <div className="tw-flex tw-gap-3 tw-p-5">
          <button
            onClick={props.onCancel}
            className="tw-flex-1 tw-py-2.5 tw-rounded-lg tw-font-medium tw-text-sm tw-cursor-pointer tw-transition-colors"
            style={{
              border: isDark ? '1px solid #333' : '1px solid #ddd',
              backgroundColor: 'transparent',
              color: isDark ? '#ccc' : '#555',
            }}
          >
            Cancel
          </button>
          <button
            onClick={props.onSave}
            disabled={saving}
            className="tw-flex-1 tw-py-2.5 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-medium tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
          >
            {saving ? (
              <span><i className="fa fa-spinner fa-spin tw-mr-2"></i>Saving...</span>
            ) : 'Save Avatar'}
          </button>
        </div>
      </div>
    </div>
  );
}

class ProfileSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      name: '',
      username: '',
      bio: '',
      profilePic: whiteBox,
      backgroundPicture: whiteBox,
      imgSrc: null,
      imgSrcExt: null,
      crop: { aspect: 1 / 1 },
      // Controlled input values
      nameInput: '',
      usernameInput: '',
      bioInput: '',
      preferredShippingInput: '',
      preferredPaymentInput: '',
      locationCity: '',
      locationState: '',
      // Saved values for dirty tracking
      savedName: '',
      savedBio: '',
      savedShipping: '',
      savedPayment: '',
      saving: false,
      selectedPreset: null,
      savingAvatar: false,
      avatarPresets: [],
      avatarSearch: '',
      appAvatarUrl: null,
      restoringAvatar: false,
      // Crop modal state
      cropModalCard: null,
      cropOffset: { x: 0, y: 0 },
      cropZoom: 2.0,
      cropDragging: false,
      cropDragStart: { x: 0, y: 0 },
      cropOffsetStart: { x: 0, y: 0 },
    };
    this.imagePreviewCanvasRef = React.createRef();
    this.fileInputRef = React.createRef();
    this.handleProfilePic = this.handleProfilePic.bind(this);
    this.handleBackgroundPicture = this.handleBackgroundPicture.bind(this);
    this.handleProfileEdit = this.handleProfileEdit.bind(this);
    this.profile = this.profile.bind(this);
  }

  componentDidMount() {
    this.profile(this.props.user._id);
    this.fetchAvatarPresets();
  }

  fetchAvatarPresets() {
    var self = this;
    fetch(constants.DOMAIN + '/api/v1/guest/avatar-presets')
      .then(function(r) { return r.json(); })
      .then(function(cards) { self.setState({ avatarPresets: cards }); })
      .catch(function() {});
  }

  profile(userId) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/' + userId, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({
        id: userId,
        name: res.profile.name,
        username: res.profile.userName,
        bio: res.profile.bio,
        profilePic: res.profile.image ? constants.DOMAIN + '/' + res.profile.image : whiteBox,
        backgroundPicture: res.profile.backgroundPicture ? constants.DOMAIN + '/' + res.profile.backgroundPicture : whiteBox,
        nameInput: res.profile.name || '',
        usernameInput: res.profile.userName || '',
        bioInput: res.profile.bio || '',
        preferredShippingInput: res.profile.preferredShipping || '',
        preferredPaymentInput: res.profile.preferredPayment || '',
        locationCity: (res.profile.address && res.profile.address.city) || '',
        locationState: (res.profile.address && res.profile.address.state) || '',
        savedName: res.profile.name || '',
        savedBio: res.profile.bio || '',
        savedShipping: res.profile.preferredShipping || '',
        savedPayment: res.profile.preferredPayment || '',
        currentImage: res.profile.image || '',
        appAvatarUrl: res.profile.appAvatarUrl || null,
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  getImageDimensions(image, obj) {
    return new Promise(function(resolve) {
      var fr = new FileReader();
      fr.onload = function() {
        var img = new Image();
        img.onload = function() {
          obj.width = img.width;
          resolve(obj);
        };
        img.src = fr.result;
      };
      fr.readAsDataURL(image);
    });
  }

  compressionWidth(width) {
    if (width > constants.MAX_IMAGE_WIDTH) {
      return constants.MAX_IMAGE_WIDTH;
    }
    if (width < constants.MAX_IMAGE_WIDTH && width >= constants.MIN_IMAGE_WIDTH) {
      return (width * 0.8).toFixed(0);
    }
    if (width < constants.MIN_IMAGE_WIDTH) {
      return width;
    }
  }

  async handleProfilePic(image) {
    if (image) {
      var data = new FormData();
      var self = this;
      var tmp = {};
      tmp = await this.getImageDimensions(image, tmp);
      new Compressor(image, {
        quality: constants.IMAGE_COMPRESSION,
        maxWidth: this.compressionWidth(tmp.width),
        success(result) {
          if (result instanceof File) {
            self.setState({ profileImage: result }, function() {
              data.append('image', self.state.profileImage);
              Auth.fetch(constants.DOMAIN + '/api/v1/users/profilepic', {
                mode: 'cors',
                method: 'POST',
                body: data,
              }).then(function(res) {
                self.setState({
                  profilePic: res.picture ? constants.DOMAIN + '/' + res.picture : whiteBox,
                  currentImage: res.picture,
                  appAvatarUrl: res.picture,
                  updatedUser: res,
                  selectedPreset: null,
                }, function() {
                  self.props.handleProfilePicChange(self.state.updatedUser);
                  window.dispatchEvent(new CustomEvent('profileUpdated'));
                  window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Profile picture saved!', type: 'success' } }));
                });
              }).catch(function(err) {
                console.log(err);
                window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to save profile picture', type: 'error' } }));
              });
            });
          } else {
            var resultFile = new File([result], result.name, { type: result.type, lastModified: Date.now() });
            self.setState({ profileImage: resultFile }, function() {
              data.append('image', self.state.profileImage);
              Auth.fetch(constants.DOMAIN + '/api/v1/users/profilepic', {
                mode: 'cors',
                method: 'POST',
                body: data,
              }).then(function(res) {
                self.setState({
                  profilePic: res.picture ? constants.DOMAIN + '/' + res.picture : whiteBox,
                  currentImage: res.picture,
                  appAvatarUrl: res.picture,
                  updatedUser: res,
                  selectedPreset: null,
                }, function() {
                  self.props.handleProfilePicChange(self.state.updatedUser);
                  window.dispatchEvent(new CustomEvent('profileUpdated'));
                  window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Profile picture saved!', type: 'success' } }));
                });
              }).catch(function(err) {
                console.log(err);
                window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to save profile picture', type: 'error' } }));
              });
            });
          }
        },
      });
    }
  }

  async handleBackgroundPicture(e) {
    var files = e.target.files;
    var image = files && files[0];
    if (image) {
      var data = new FormData();
      var self = this;
      var tmp = {};
      tmp = await this.getImageDimensions(image, tmp);
      new Compressor(image, {
        quality: constants.IMAGE_COMPRESSION,
        maxWidth: this.compressionWidth(tmp.width),
        success(result) {
          if (result instanceof File) {
            self.setState({ backgroundImage: result }, function() {
              data.append('backgroundPicture', self.state.backgroundImage);
              Auth.fetch(constants.DOMAIN + '/api/v1/users/profilebackground', {
                mode: 'cors',
                method: 'POST',
                body: data,
              }).then(function(res) {
                self.setState({
                  backgroundPicture: constants.DOMAIN + '/' + res.backgroundPicture,
                }, function() {
                  Auth.fetch(constants.DOMAIN + '/api/v1/users/' + self.state.id, {
                    mode: 'cors',
                    method: 'GET',
                  }).then(function(response) {
                    self.setState({ user: response.profile }, function() {
                      self.props.handleBackgroundPicChange(self.state.user);
                      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Banner saved!', type: 'success' } }));
                    });
                  }).catch(function(err) { console.log(err); });
                });
              }).catch(function(err) {
                console.log(err);
                window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to save banner', type: 'error' } }));
              });
            });
          } else {
            var resultFile = new File([result], result.name, { type: result.type, lastModified: Date.now() });
            self.setState({ backgroundImage: resultFile }, function() {
              data.append('backgroundPicture', self.state.backgroundImage);
              Auth.fetch(constants.DOMAIN + '/api/v1/users/profilebackground', {
                mode: 'cors',
                method: 'POST',
                body: data,
              }).then(function(res) {
                self.setState({
                  backgroundPicture: constants.DOMAIN + '/' + res.backgroundPicture,
                }, function() {
                  Auth.fetch(constants.DOMAIN + '/api/v1/users/' + self.state.id, {
                    mode: 'cors',
                    method: 'GET',
                  }).then(function(response) {
                    self.setState({ user: response.profile }, function() {
                      self.props.handleBackgroundPicChange(self.state.user);
                      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Banner saved!', type: 'success' } }));
                    });
                  }).catch(function(err) { console.log(err); });
                });
              }).catch(function(err) {
                console.log(err);
                window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to save banner', type: 'error' } }));
              });
            });
          }
        },
      });
    }
  }

  handleProfileEdit() {
    var data = new URLSearchParams();
    var name = this.state.nameInput;
    if (name) data.append('name', name);
    var username = this.state.usernameInput;
    if (username) data.append('userName', username);
    var bio = this.state.bioInput;
    if (bio) data.append('bio', bio);
    data.append('preferredShipping', this.state.preferredShippingInput || '');
    data.append('preferredPayment', this.state.preferredPaymentInput || '');

    var self = this;
    this.setState({ saving: true });
    Auth.fetch(constants.DOMAIN + '/api/v1/users/profile', {
      mode: 'cors',
      method: 'PATCH',
      body: data,
    }).then(function(res) {
      Auth.setToken(res.token);
      self.setState({
        name: res.name,
        username: res.userName,
        bio: res.bio,
        nameInput: res.name || '',
        usernameInput: res.userName || '',
        bioInput: res.bio || '',
        preferredShippingInput: res.preferredShipping || '',
        preferredPaymentInput: res.preferredPayment || '',
        savedName: res.name || '',
        savedBio: res.bio || '',
        savedShipping: res.preferredShipping || '',
        savedPayment: res.preferredPayment || '',
        saving: false,
      }, function() {
        self.props.handleProfileChange(self.state.name, self.state.username, self.state.bio);
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Profile saved!', type: 'success' } }));
      });
    }).catch(function(err) {
      self.setState({ saving: false });
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Someone already has that username', type: 'error' } }));
      console.log(err);
    });
  }

  handleAvatarPreset(card) {
    if (this.state.savingAvatar) return;
    this.setState({
      cropModalCard: card,
      cropOffset: { x: 0, y: 80 },
      cropZoom: 1.3,
      cropDragging: false,
    });
  }

  handleCropMouseDown(e) {
    e.preventDefault();
    this.setState({
      cropDragging: true,
      cropDragStart: { x: e.clientX, y: e.clientY },
      cropOffsetStart: { x: this.state.cropOffset.x, y: this.state.cropOffset.y },
    });
  }

  handleCropMouseMove(e) {
    if (!this.state.cropDragging) return;
    var dx = e.clientX - this.state.cropDragStart.x;
    var dy = e.clientY - this.state.cropDragStart.y;
    var containerSize = 260;
    var cardAspect = 1.4; // TCG cards are ~1.4x taller than wide
    var maxOffsetX = (containerSize * (this.state.cropZoom - 1)) / 2;
    var maxOffsetY = (containerSize * (this.state.cropZoom * cardAspect - 1)) / 2;
    var newX = Math.max(-maxOffsetX, Math.min(maxOffsetX, this.state.cropOffsetStart.x + dx));
    var newY = Math.max(-maxOffsetY, Math.min(maxOffsetY, this.state.cropOffsetStart.y + dy));
    this.setState({ cropOffset: { x: newX, y: newY } });
  }

  handleCropMouseUp() {
    this.setState({ cropDragging: false });
  }

  handleCropTouchStart(e) {
    if (e.touches.length !== 1) return;
    var touch = e.touches[0];
    this.setState({
      cropDragging: true,
      cropDragStart: { x: touch.clientX, y: touch.clientY },
      cropOffsetStart: { x: this.state.cropOffset.x, y: this.state.cropOffset.y },
    });
  }

  handleCropTouchMove(e) {
    if (!this.state.cropDragging || e.touches.length !== 1) return;
    e.preventDefault();
    var touch = e.touches[0];
    var dx = touch.clientX - this.state.cropDragStart.x;
    var dy = touch.clientY - this.state.cropDragStart.y;
    var containerSize = 260;
    var cardAspect = 1.4;
    var maxOffsetX = (containerSize * (this.state.cropZoom - 1)) / 2;
    var maxOffsetY = (containerSize * (this.state.cropZoom * cardAspect - 1)) / 2;
    var newX = Math.max(-maxOffsetX, Math.min(maxOffsetX, this.state.cropOffsetStart.x + dx));
    var newY = Math.max(-maxOffsetY, Math.min(maxOffsetY, this.state.cropOffsetStart.y + dy));
    this.setState({ cropOffset: { x: newX, y: newY } });
  }

  handleCropTouchEnd() {
    this.setState({ cropDragging: false });
  }

  handleCropZoomChange(e) {
    var newZoom = parseFloat(e.target.value);
    var containerSize = 260;
    var cardAspect = 1.4;
    var maxOffsetX = (containerSize * (newZoom - 1)) / 2;
    var maxOffsetY = (containerSize * (newZoom * cardAspect - 1)) / 2;
    var newX = Math.max(-maxOffsetX, Math.min(maxOffsetX, this.state.cropOffset.x));
    var newY = Math.max(-maxOffsetY, Math.min(maxOffsetY, this.state.cropOffset.y));
    this.setState({ cropZoom: newZoom, cropOffset: { x: newX, y: newY } });
  }

  handleCropCancel() {
    this.setState({ cropModalCard: null, cropDragging: false });
  }

  handleCropSave() {
    if (this.state.savingAvatar) return;
    var self = this;
    var card = this.state.cropModalCard;
    if (!card) return;

    this.setState({ savingAvatar: true });

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function() {
      var canvas = document.createElement('canvas');
      var outputSize = 400;
      canvas.width = outputSize;
      canvas.height = outputSize;
      var ctx = canvas.getContext('2d');

      var containerSize = 260;
      var zoom = self.state.cropZoom;
      var offsetX = self.state.cropOffset.x;
      var offsetY = self.state.cropOffset.y;

      // Convert visual offset+zoom into canvas drawImage source coordinates
      // Image is displayed at width=containerSize, height=auto, so pixels-per-CSS-pixel
      // is the same in both axes: imgW / containerSize
      var imgW = img.naturalWidth;
      var imgH = img.naturalHeight;
      var pixelsPerCss = imgW / containerSize;

      // Visible square region in image coordinates (container is square)
      var visibleSize = containerSize / zoom * pixelsPerCss; // = imgW / zoom

      // Center of visible region in image coordinates
      var cx = (imgW / 2) - (offsetX * pixelsPerCss / zoom);
      var cy = (imgH / 2) - (offsetY * pixelsPerCss / zoom);

      var sx = cx - visibleSize / 2;
      var sy = cy - visibleSize / 2;

      ctx.drawImage(img, sx, sy, visibleSize, visibleSize, 0, 0, outputSize, outputSize);

      canvas.toBlob(function(blob) {
        if (!blob) {
          self.setState({ savingAvatar: false });
          window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to crop avatar', type: 'error' } }));
          return;
        }
        var data = new FormData();
        data.append('image', blob, 'avatar.png');
        Auth.fetch(constants.DOMAIN + '/api/v1/users/profilepic?source=preset', {
          mode: 'cors',
          method: 'POST',
          body: data,
        }).then(function(res) {
          self.setState({
            profilePic: res.picture ? constants.DOMAIN + '/' + res.picture : whiteBox,
            currentImage: res.picture,
            selectedPreset: card._id,
            savingAvatar: false,
            cropModalCard: null,
          }, function() {
            self.props.handleProfilePicChange(res);
            window.dispatchEvent(new CustomEvent('profileUpdated'));
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Avatar updated!', type: 'success' } }));
          });
        }).catch(function(err) {
          console.log(err);
          self.setState({ savingAvatar: false });
          window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to set avatar', type: 'error' } }));
        });
      }, 'image/png');
    };
    img.onerror = function() {
      self.setState({ savingAvatar: false });
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to load card image', type: 'error' } }));
    };
    img.src = resolveCardImage(card.image);
  }

  // IMAGE CROPPING
  handleImageLoaded = (image) => {}

  handleOnCropChange = (crop) => {
    this.setState({ crop: crop });
  }

  handleOnCropComplete = (crop, pixelCrop) => {
    var canvasRef = this.imagePreviewCanvasRef.current;
    image64toCanvasRef(canvasRef, this.state.imgSrc, pixelCrop, this.state.orientation);
  }

  handleDownloadClick = (event) => {
    event.preventDefault();
    if (this.state.imgSrc) {
      var canvasRef = this.imagePreviewCanvasRef.current;
      var imageData64 = canvasRef.toDataURL('image/' + this.state.imgSrcExt);
      var myFilename = 'previewFile.' + this.state.imgSrcExt;
      var myNewCroppedFile = base64StringtoFile(imageData64, myFilename);
      this.handleProfilePic(myNewCroppedFile);
      this.handleClearToDefault();
    }
  }

  handleClearToDefault = (event) => {
    if (event) event.preventDefault();
    var canvas = this.imagePreviewCanvasRef.current;
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.setState({
      imgSrc: null,
      imgSrcExt: null,
      crop: { aspect: 1 / 1 },
    });
    this.fileInputRef.current.value = null;
  }

  verifyFile = (files) => {
    if (files && files.length > 0) {
      var currentFile = files[0];
      var currentFileType = currentFile.type;
      var currentFileSize = currentFile.size;
      if (currentFileSize > imageMaxSize) {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'File is too large', type: 'error' } }));
        return false;
      }
      if (!acceptedFileTypesArray.includes(currentFileType)) {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Only image files are allowed', type: 'error' } }));
        return false;
      }
      return true;
    }
  }

  handleFileSelect = (event) => {
    var files = event.target.files;
    if (files && files.length > 0) {
      var isVerified = this.verifyFile(files);
      if (isVerified) {
        var currentFile = files[0];
        var self = this;
        this.getOrientation(currentFile, function(orientation) {
          self.setState({ orientation: orientation });
        });
        loadImage(currentFile, function(img) {
          var base64data = img.toDataURL('image/jpeg');
          self.setState({
            imgSrc: base64data,
            imgSrcExt: extractImageFileExtensionFromBase64(base64data),
          });
        }, { orientation: true });
      }
    }
  }

  getOrientation(file, callback) {
    var reader = new FileReader();
    reader.onload = function(e) {
      var view = new DataView(e.target.result);
      // eslint-disable-next-line
      if (view.getUint16(0, false) != 0xFFD8) return callback(-2);
      var length = view.byteLength;
      var offset = 2;
      while (offset < length) {
        if (view.getUint16(offset + 2, false) <= 8) return callback(-1);
        var marker = view.getUint16(offset, false);
        offset += 2;
        // eslint-disable-next-line
        if (marker == 0xFFE1) {
          // eslint-disable-next-line
          if (view.getUint32(offset += 2, false) != 0x45786966) return callback(-1);
          // eslint-disable-next-line
          var little = view.getUint16(offset += 6, false) == 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++) {
            // eslint-disable-next-line
            if (view.getUint16(offset + (i * 12), little) == 0x0112) {
              return callback(view.getUint16(offset + (i * 12) + 8, little));
            }
          }
          // eslint-disable-next-line
        } else if ((marker & 0xFF00) != 0xFF00) {
          break;
        } else {
          offset += view.getUint16(offset, false);
        }
      }
      return callback(-1);
    };
    reader.readAsArrayBuffer(file);
  }

  hasChanges() {
    return (
      this.state.nameInput !== this.state.savedName ||
      this.state.bioInput !== this.state.savedBio ||
      this.state.preferredShippingInput !== this.state.savedShipping ||
      this.state.preferredPaymentInput !== this.state.savedPayment
    );
  }

  render() {
    var self = this;
    var inputClass = 'tw-w-full tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-rounded-xl tw-px-5 tw-py-3 tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] focus:tw-border-brand-gold tw-outline-none tw-text-[#111] dark:tw-text-white tw-transition-colors';
    var labelClass = 'tw-block tw-text-sm tw-font-medium tw-text-[#555] dark:tw-text-[#aaa] tw-mb-2';
    var cardClass = 'tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-p-6 tw-mb-6';
    var cardStyle = { border: '1px solid #e0e0e0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
    var hasChanges = this.hasChanges();

    return (
      <div>
        {/* Photos Section */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Profile Photo</h3>

          {/* Profile Picture */}
          <div className="tw-mb-4">
            <label className={labelClass}>Profile Photo</label>
            <div className="tw-flex tw-items-center tw-gap-4">
              <div className="tw-relative tw-flex-shrink-0">
                <img
                  src={this.state.profilePic}
                  alt="Profile"
                  className="tw-w-24 tw-h-24 tw-rounded-full tw-object-cover"
                  style={{ border: '3px solid #c9a84c' }}
                />
              </div>
              <div>
                <label
                  htmlFor="profilePictureInput"
                  className="tw-inline-block tw-px-4 tw-py-2 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-medium tw-text-sm tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors"
                >
                  <i className="fa fa-camera tw-mr-2"></i>Change Photo
                </label>
                <p className="tw-text-xs tw-text-[#888] tw-mt-2">Best quality with square images</p>
              </div>
            </div>
            <input
              ref={this.fileInputRef}
              type="file"
              id="profilePictureInput"
              style={{ display: 'none' }}
              onChange={this.handleFileSelect}
              multiple={false}
              accept={acceptedFileTypes}
            />
          </div>

          {/* Restore App Avatar */}
          {this.state.appAvatarUrl && this.state.currentImage !== this.state.appAvatarUrl ? (
            <div className="tw-mt-4 tw-pt-4" style={{ borderTop: '1px solid #e0e0e0' }}>
              <label className={labelClass}>Your imported photo</label>
              <button
                onClick={function() {
                  if (self.state.restoringAvatar) return;
                  self.setState({ restoringAvatar: true });
                  Auth.fetch(constants.DOMAIN + '/api/v1/users/restore-avatar', {
                    mode: 'cors',
                    method: 'POST',
                  }).then(function(res) {
                    self.setState({
                      profilePic: res.picture ? constants.DOMAIN + '/' + res.picture : whiteBox,
                      currentImage: res.picture,
                      selectedPreset: null,
                      restoringAvatar: false,
                    }, function() {
                      self.props.handleProfilePicChange({ picture: res.picture });
                      window.dispatchEvent(new CustomEvent('profileUpdated'));
                      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Photo restored!', type: 'success' } }));
                    });
                  }).catch(function() {
                    self.setState({ restoringAvatar: false });
                    window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to restore photo', type: 'error' } }));
                  });
                }}
                disabled={this.state.restoringAvatar}
                className="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-lg tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] tw-bg-transparent tw-cursor-pointer hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#0f0f0f] tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              >
                <div
                  className="tw-w-12 tw-h-12 tw-rounded-full tw-bg-cover tw-bg-center tw-flex-shrink-0"
                  style={{ backgroundImage: 'url(' + constants.DOMAIN + '/' + this.state.appAvatarUrl + ')', border: '2px solid #c9a84c' }}
                ></div>
                <div className="tw-text-left">
                  <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">
                    {this.state.restoringAvatar ? 'Restoring...' : 'Use Your Photo'}
                  </p>
                  <p className="tw-text-xs tw-text-[#888]">Restore your imported profile picture</p>
                </div>
              </button>
            </div>
          ) : null}

          {/* Avatar Presets — Card Art */}
          {this.state.avatarPresets.length > 0 ? (
            <div className="tw-mt-4 tw-pt-4" style={{ borderTop: '1px solid #e0e0e0' }}>
              <label className={labelClass}>Or choose a card avatar</label>
              <input
                type="text"
                className={inputClass + ' tw-mb-3'}
                placeholder="Search characters..."
                value={this.state.avatarSearch}
                onChange={function(e) { self.setState({ avatarSearch: e.target.value }); }}
              />
              <div className="tw-grid tw-grid-cols-5 sm:tw-grid-cols-8 tw-gap-2" style={{ maxHeight: '240px', overflowY: 'auto' }}>
                {this.state.avatarPresets
                  .filter(function(c) {
                    if (!self.state.avatarSearch) return true;
                    return c.name.toLowerCase().indexOf(self.state.avatarSearch.toLowerCase()) !== -1;
                  })
                  .map(function(card) {
                    var isSelected = self.state.selectedPreset === card._id ||
                      (self.state.currentImage && self.state.currentImage === card.image);
                    return (
                      <button
                        key={card._id}
                        title={card.name + ' (' + card.rarity + ')'}
                        onClick={function() { self.handleAvatarPreset(card); }}
                        disabled={self.state.savingAvatar}
                        className="tw-relative tw-w-full tw-rounded-full tw-cursor-pointer tw-border-none tw-p-0 tw-transition-transform hover:tw-scale-105 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                        style={Object.assign(
                          {
                            aspectRatio: '1',
                            outline: isSelected ? '3px solid #c9a84c' : 'none',
                            outlineOffset: '2px',
                            backgroundImage: 'url(' + resolveCardImage(card.image) + ')',
                            backgroundSize: '190%',
                            backgroundPosition: 'center 22%',
                            backgroundRepeat: 'no-repeat',
                          },
                          isSelected ? { transform: 'scale(1.05)' } : {}
                        )}
                        aria-label={card.name}
                      />
                    );
                  })}
              </div>
            </div>
          ) : null}

          {/* Crop Area */}
          {this.state.imgSrc !== null ? (
            <div className="tw-mt-4 tw-p-4 tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-rounded-xl">
              <ReactCrop
                src={this.state.imgSrc}
                crop={this.state.crop}
                onImageLoaded={this.handleImageLoaded}
                onComplete={this.handleOnCropComplete}
                onChange={this.handleOnCropChange}
              />
              <div className="tw-mt-4">
                <h4 className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white tw-mb-3">Crop your picture</h4>
                <canvas ref={this.imagePreviewCanvasRef} className="tw-max-w-full tw-rounded-lg" />
                {this.state.crop.height ? (
                  <div className="tw-flex tw-gap-3 tw-mt-4">
                    <button
                      onClick={this.handleDownloadClick}
                      className="tw-px-6 tw-py-2 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-medium tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors"
                    >
                      Choose
                    </button>
                    <button
                      onClick={this.handleClearToDefault}
                      className="tw-px-6 tw-py-2 tw-rounded-lg tw-border tw-border-brand-gold tw-text-brand-gold tw-font-medium tw-text-sm tw-bg-transparent tw-cursor-pointer hover:tw-bg-brand-gold/10 tw-transition-colors"
                    >
                      Clear
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}
        </div>

        {/* Profile Info Section */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Profile Info</h3>

          <div className="tw-space-y-4">
            <div>
              <label className={labelClass}>Name</label>
              <input
                type="text"
                className={inputClass}
                value={this.state.nameInput}
                onChange={function(e) { self.setState({ nameInput: e.target.value }); }}
                placeholder="Your name"
              />
            </div>

            <div>
              <label className={labelClass}>Store Bio</label>
              <textarea
                className={inputClass + ' tw-resize-none'}
                value={this.state.bioInput}
                onChange={function(e) { self.setState({ bioInput: e.target.value }); }}
                placeholder="Tell people about yourself"
                maxLength="100"
                rows="3"
              />
              <p className="tw-text-xs tw-text-[#888] tw-mt-1">{(this.state.bioInput || '').length}/100</p>
            </div>

          </div>
        </div>

        {/* Location & Shipping Section */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Location & Shipping</h3>

          <div className="tw-space-y-4">
            <div className="tw-grid tw-grid-cols-2 tw-gap-4">
              <div>
                <label className={labelClass}>City</label>
                <input
                  type="text"
                  className={inputClass}
                  value={this.state.locationCity}
                  readOnly
                  style={{ opacity: 0.6, cursor: 'default' }}
                  placeholder="Not set"
                />
              </div>
              <div>
                <label className={labelClass}>State</label>
                <input
                  type="text"
                  className={inputClass}
                  value={this.state.locationState}
                  readOnly
                  style={{ opacity: 0.6, cursor: 'default' }}
                  placeholder="Not set"
                />
              </div>
            </div>
            <p className="tw-text-xs tw-text-[#888]">
              <i className="fa fa-info-circle tw-mr-1"></i>
              Update your address in <span className="tw-text-brand-gold tw-cursor-pointer" onClick={function() { if (self.props.onSwitchTab) self.props.onSwitchTab('account'); }}>Account Settings</span>
            </p>

            <div>
              <label className={labelClass}>Preferred Shipping</label>
              <select
                className={inputClass}
                value={this.state.preferredShippingInput}
                onChange={function(e) { self.setState({ preferredShippingInput: e.target.value }); }}
              >
                <option value="">Select shipping carrier</option>
                <option value="USPS">USPS</option>
                <option value="UPS">UPS</option>
                <option value="FedEx">FedEx</option>
              </select>
            </div>

            <div>
              <label className={labelClass}>Preferred Payment</label>
              <select
                className={inputClass}
                value={this.state.preferredPaymentInput}
                onChange={function(e) { self.setState({ preferredPaymentInput: e.target.value }); }}
              >
                <option value="">Select payment method</option>
                <option value="PayPal">PayPal</option>
                <option value="Credit Card">Credit Card</option>
                <option value="No Preference">No Preference</option>
              </select>
            </div>
          </div>
        </div>


        {/* Sticky Save Bar */}
        {hasChanges ? (
          <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-50 tw-bg-white dark:tw-bg-[#1a1a1a] tw-py-3 tw-px-4" style={{ borderTop: '1px solid #e0e0e0', boxShadow: '0 -2px 12px rgba(0,0,0,0.1)' }}>
            <div className="tw-max-w-6xl tw-mx-auto tw-flex tw-items-center tw-justify-between">
              <span className="tw-text-sm tw-text-[#888]">
                <i className="fa fa-circle tw-text-brand-gold tw-text-[8px] tw-mr-2" style={{ verticalAlign: 'middle' }}></i>
                Unsaved changes
              </span>
              <button
                onClick={this.handleProfileEdit}
                disabled={this.state.saving}
                className="tw-px-8 tw-py-2.5 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              >
                {this.state.saving ? 'Saving...' : 'Save Profile'}
              </button>
            </div>
          </div>
        ) : null}

        {/* Avatar Crop Modal */}
        {this.state.cropModalCard ? (
          <AvatarCropModal
            card={this.state.cropModalCard}
            zoom={this.state.cropZoom}
            offset={this.state.cropOffset}
            saving={this.state.savingAvatar}
            dragging={this.state.cropDragging}
            onMouseDown={function(e) { self.handleCropMouseDown(e); }}
            onMouseMove={function(e) { self.handleCropMouseMove(e); }}
            onMouseUp={function() { self.handleCropMouseUp(); }}
            onTouchStart={function(e) { self.handleCropTouchStart(e); }}
            onTouchMove={function(e) { self.handleCropTouchMove(e); }}
            onTouchEnd={function() { self.handleCropTouchEnd(); }}
            onZoomChange={function(e) { self.handleCropZoomChange(e); }}
            onSave={function() { self.handleCropSave(); }}
            onCancel={function() { self.handleCropCancel(); }}
          />
        ) : null}
      </div>
    );
  }
}

export default ProfileSettings;
